import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import en from "./i18n/en";
import tr from "./i18n/tr";
import fr from "./i18n/fr";
import bg from "./i18n/bg";
import el from "./i18n/el";
import es from "./i18n/es";
import it from "./i18n/it";
import ru from "./i18n/ru";

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "tr",
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: en,
      tr: tr,
      fr: fr,
      bg: bg,
      el: el,
      es: es,
      it: it,
      ru: ru,
    },
  });

export default i18n;
